
import { CategoryCard } from "../../components/category-card/CategoryCard";
import "./CategoriesTop.css";

export function CategoriesTop() {
  return (
    <div className="">
      <h2 className="provider-title">
        Categorias que pueden interesarte
      </h2>
    <div className="categories-top">
      <CategoryCard
        image="/assets/icons/medicos.svg"
      />
      <CategoryCard
        image="/assets/icons/farmacia.svg"
      />
      <CategoryCard
        image="/assets/icons/hospitales.svg"
      />
      <CategoryCard
        image="/assets/icons/gym.svg"
      />
    </div>
    </div>
  );
}